import { Pipe, PipeTransform } from '@angular/core';
import { CompanyType, CompanyTypeLabels } from '@models/companies/company-enums';

@Pipe({
  standalone: true,
  name: 'companyType'
})
export class CompanyTypePipe implements PipeTransform {
  transform(value: CompanyType | undefined): string {
    if (value != undefined)
      return CompanyTypeLabels[value];
    return '-';
  }
}
